import { Col, Row } from 'react-bootstrap';
import FormWrapper from '../../Reusable/FormWrapper/FormWrapper';
import InputField from '../../Reusable/InputField';
import CustomCheckBox from '../../Reusable/CustomCheckBox';
import ComboBoxAutocomplete from '../../Reusable/ComboBoxAutocomplete';
import { Tooltip } from '@mui/material';
import { ActionTypes, getOperationIcons, getOrderNumbers } from '../utils';

const ActionsSettingsForm = (props) => {
  const {
      submitRef,
      translations,
      settingsState,
      orderNumbers,
      onSubmit,
      onChange,
      onCheckBoxChange,
      onComboBoxChange,
      removeErrors,
    } = props || {},
    { Placeholders, Tooltips } = translations || {};

  return (
    <FormWrapper submitRef={submitRef} onSubmit={onSubmit}>
      {settingsState?.map((setting) => {
        const comboOrderNumbers = getOrderNumbers(
          setting,
          settingsState,
          orderNumbers
        );
        const iconOptions = getOperationIcons(setting?.type);

        return (
          <Row key={setting?.type} className="responsive-form-row">
            <Col
              md={2}
              className="d-flex justify-content-start align-items-center"
            >
              <Tooltip title={setting?.description || Tooltips?.notAvailable}>
                <label className={'text-bold'}>{setting.type}:</label>
              </Tooltip>
            </Col>
            <Col md={3}>
              <InputField
                id="label"
                name={'label'}
                placeholder={Placeholders.label}
                onChange={(e) => onChange(e, setting?.index)}
                value={setting?.label}
                required
                error={setting?.errors}
                errorsHandler={() => removeErrors('label', setting?.index)}
              />
            </Col>
            <Col md={2}>
              <ComboBoxAutocomplete
                id="icon"
                data={iconOptions}
                textExtractor={(a) => a}
                label={Placeholders.icon}
                updateValue={setting?.icon}
                required
                error={setting?.errors}
                errorsHandler={() => removeErrors('icon', setting?.index)}
                changeValue={(value) =>
                  onComboBoxChange('icon', value, setting?.index)
                }
                startAdornment={
                  setting?.icon && (
                    <i
                      className={`ml-1 fas ${setting?.icon} darker-gray-icon-color`}
                    />
                  )
                }
                renderOption={(option) => (
                  <section key={`${option}_${setting?.id}`}>
                    <i className={`fas ${option} darker-gray-icon-color`} />
                  </section>
                )}
                filterSelectedOptions
                inputDisabled
                classNameTextField="muted-text"
              />
            </Col>
            <Col md={2} className="text-center">
              <CustomCheckBox
                name="hide"
                className="w-100 text-center"
                onChange={(e) => onCheckBoxChange(e, setting?.index)}
                checked={setting?.hide}
                label={Placeholders?.hide}
                labelPlacement="top"
                classNameLabel={`font-size-14`}
              />
            </Col>
            <Col md={3}>
              <ComboBoxAutocomplete
                id="orderNum"
                data={comboOrderNumbers}
                textExtractor={(a) => `${a}`}
                required
                changeValue={(value) =>
                  onComboBoxChange('orderNum', value, setting?.index)
                }
                label={Placeholders?.orderNum}
                updateValue={setting?.orderNum}
                error={setting?.errors}
                errorsHandler={() => removeErrors('orderNum', setting?.index)}
                disabled={setting?.hide || setting?.type === ActionTypes.CREATE}
              />
            </Col>
          </Row>
        );
      })}
    </FormWrapper>
  );
};

export default ActionsSettingsForm;
